import styled from 'styled-components';

export const Logo = styled.img`
  height: ${({ height }) => height ?? '30px'};
`;
